export default "data:text/javascript;base64,aW1wb3J0IE1hcFlhbmRleCBmcm9tICcuL01hcFlhbmRleC52dWUnDQpleHBvcnQgeyBNYXBZYW5kZXggfQ0K"